export default class DisableAddressInputs {
    constructor() {
        this.checkout = document.querySelector(".woocommerce-checkout");
        this.address = document.querySelector(".woocommerce-edit-address");
        this.account = document.querySelector('.woocommerce-edit-account');

        if ( this.checkout || this.address ) {
            this.disableInputs();
        }
    }

    disableInputs() {
        const vatCheckbox = document.getElementById("fv_checkbox_fv");
        if (vatCheckbox) {
            vatCheckbox.checked = true;
        }

        const nipInput = document.getElementById("vat_number");
        if (nipInput) {
            nipInput.readOnly = true;
            nipInput.style.opacity = "0.5";
        }
        const accountEmail = document.getElementById('account_email');
        if (accountEmail) {
            accountEmail.readOnly = true;
            accountEmail.style.opacity = "0.5";
        }

        const inputs = ["first_name", "last_name", "company", "address_1", "address_2", "postcode", "city", "email"];

        inputs.forEach((el, index) => {
            const inputField = document.getElementById("billing_" + el);

            if (inputField) {
                inputField.readOnly = true;
                inputField.style.opacity = "0.5";
            }
        });

        const selects = ["country", "province_field"];

        selects.forEach(select => {
            const selectField = document.querySelector(`select[name="billing_${select}"]`);

            if(selectField) {
                selectField.style.opacity = "0.5";
                selectField.style.pointerEvents = "none";
                selectField.style.touchAction = "none";
            }
        });
    }
}
